import React from 'react'

const SupportSMS = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <g clipPath="url(#clip0_2389_59390)">
        <path
          d="M14.2502 3.66683V10.0835H5.23933L4.16683 11.156V3.66683H14.2502ZM15.1668 1.8335H3.25016C2.746 1.8335 2.3335 2.246 2.3335 2.75016V15.5835L6.00016 11.9168H15.1668C15.671 11.9168 16.0835 11.5043 16.0835 11.0002V2.75016C16.0835 2.246 15.671 1.8335 15.1668 1.8335ZM19.7502 5.50016H17.9168V13.7502H6.00016V15.5835C6.00016 16.0877 6.41266 16.5002 6.91683 16.5002H17.0002L20.6668 20.1668V6.41683C20.6668 5.91266 20.2543 5.50016 19.7502 5.50016Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2389_59390">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SupportSMS
